const content = [require("./0/index").default];

export default content;
